import EditMembershipOffersComponent from 'components/membershipOffers/editMembershipOffers';

const AddMembershipOffersPage = () => {
  return <EditMembershipOffersComponent />;
};

export default AddMembershipOffersPage;
